import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ServiceDTO } from '@core/apis/service/service.dto';
import { BookingStorageEnum } from '@core/enums/booking.enum';
import { IBookingStorageDeleteEvent } from '@core/interfaces/booking.interface';
import { FormatTimePipe } from '@core/pipes/format-time.pipe';
import { TranslocoModule } from '@jsverse/transloco';
import { ProductCardComponent } from '../product-card/product-card.component';

@Component({
  selector: 'app-service-view',
  imports: [
    CommonModule,
    TranslocoModule,
    FormatTimePipe,
    ProductCardComponent,
  ],
  templateUrl: './service-view.component.html',
  styleUrl: './service-view.component.scss',
})
export class ServiceViewComponent {
  @Input({ required: true }) public program!: ServiceDTO;
  @Output('delete') public delete: EventEmitter<IBookingStorageDeleteEvent> =
    new EventEmitter();

  public teamPath: string = '';

  public readonly BookingStorageEnum = BookingStorageEnum;
  public ngOnInit(): void {
    this.teamPath = `services`;
  }
}
